module.exports = __webpack_public_path__ + "img/avater.0934f57a.png";